import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services/api';


// Create Device
export const listTotalEnergy = createAsyncThunk('influx/listTotalEnergy', async (payload: object) => {
    const response = await api.post('/influx', payload);
    return response.data;
});
